var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliverable
    ? _c(
        "div",
        { staticClass: "edit-deliverable-modal dup-deliverable-detail" },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "tags__wrapper" }, [
                  _c("div", { staticClass: "deliverable-list-tags" }, [
                    _c("span", { staticClass: "text-uppercase field-label" }, [
                      _vm._v("Tags")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "info-bubbles cursor-pointer exclude-outside-click"
                      },
                      [
                        _vm._l(_vm.deliverable.tags, function(tag) {
                          return _c(
                            "span",
                            {
                              key: "dup-prev-tag-" + tag.tag_id,
                              staticClass:
                                "exclude-outside-click badge badge-gray deliverable-tags"
                            },
                            [_vm._v(_vm._s(tag.name))]
                          )
                        }),
                        _vm._v(" "),
                        !_vm.hasTags
                          ? _c("span", { staticClass: "text-muted" }, [
                              _vm._v("—")
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "field-box" }, [
                        _c(
                          "div",
                          { staticClass: "field-container--notes_research" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", { staticClass: "field-wrap" }, [
                              _vm.deliverable.description
                                ? _c("div", {
                                    staticClass: "dup-preview-description",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.deliverable.description
                                      )
                                    }
                                  })
                                : _c("span", { staticClass: "text-muted" }, [
                                    _vm._v("—")
                                  ])
                            ])
                          ]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm.deliverable.coordinator_name
                      ? _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "field-box" }, [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("div", { staticClass: "field-wrap" }, [
                              _c(
                                "span",
                                { staticClass: "field-value text-hover-bg" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.deliverable.coordinator_name)
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "field-box" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _vm.hasOutlets
                          ? _c(
                              "div",
                              _vm._l(_vm.deliverable.outlets, function(outlet) {
                                return _c(
                                  "div",
                                  {
                                    key: "dup-prev-outlet-" + outlet.contact_id,
                                    staticClass: "contact-box"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "contact-box__name" },
                                      [_vm._v(_vm._s(outlet.contact_name))]
                                    ),
                                    _vm._v(" "),
                                    outlet.position
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "contact-box__position"
                                          },
                                          [_vm._v(_vm._s(outlet.position))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    outlet.company_name
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "contact-box__company_name"
                                          },
                                          [_vm._v(_vm._s(outlet.company_name))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    outlet.phone
                                      ? _c(
                                          "div",
                                          { staticClass: "contact-box__phone" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "tel:" + outlet.phone
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "T: " + _vm._s(outlet.phone)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    outlet.address
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "contact-box__address"
                                          },
                                          [_vm._v(_vm._s(outlet.address))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    outlet.city
                                      ? _c(
                                          "div",
                                          { staticClass: "contact-box__city" },
                                          [_vm._v(_vm._s(outlet.city))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    outlet.province
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "contact-box__province"
                                          },
                                          [_vm._v(_vm._s(outlet.province))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    outlet.country_id
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "contact-box__country_id"
                                          },
                                          [_vm._v(_vm._s(outlet.country_id))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    outlet.postal_code
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "contact-box__postal_code"
                                          },
                                          [_vm._v(_vm._s(outlet.postal_code))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    outlet.region
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "contact-box__region"
                                          },
                                          [_vm._v(_vm._s(outlet.region))]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              }),
                              0
                            )
                          : _c(
                              "span",
                              { staticClass: "text-muted d-block pb-2" },
                              [_vm._v("—")]
                            )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 field-box" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-box__content" }, [
                        _vm.hasResources
                          ? _c(
                              "div",
                              _vm._l(_vm.deliverable.resources, function(
                                resource,
                                i
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: "dup-prev-res-" + i,
                                    staticClass: "resource-box"
                                  },
                                  [
                                    _c("div", { staticClass: "media" }, [
                                      _c("div", { staticClass: "media-body" }, [
                                        _c("div", {
                                          staticClass: "resource-box__url"
                                        }),
                                        _vm._v(" "),
                                        resource.url
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: resource.url,
                                                  target: "_blank",
                                                  rel: "noopener noreferrer"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    resource.label ||
                                                      resource.url
                                                  )
                                                )
                                              ]
                                            )
                                          : _c("span", [
                                              _vm._v(_vm._s(resource.label))
                                            ]),
                                        _vm._v(" "),
                                        resource.notes
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "resource-box__notes"
                                              },
                                              [_vm._v(_vm._s(resource.notes))]
                                            )
                                          : _vm._e()
                                      ])
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          : _c("span", { staticClass: "text-muted" }, [
                              _vm._v("—")
                            ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { attrs: { id: "task__field__labels" } }, [
                _c("div", { staticClass: "field-block d-flex flex-row" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row sortable--fields" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "field-control-wrapper field-control-wrapper__title no-radius no-draggable-field"
                        },
                        [
                          _c("div", { staticClass: "task-title" }, [
                            _c(
                              "div",
                              { staticClass: "az task-table-header__task" },
                              [
                                _vm._v("\n                  Tasks "),
                                _c(
                                  "span",
                                  { staticClass: "task-count-second" },
                                  [_vm._v("(" + _vm._s(_vm.taskCount) + ")")]
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      false
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__due_date"
                            },
                            [_vm._m(7)]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._m(8),
                      _vm._v(" "),
                      _vm._m(9)
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "task-fields" },
                [
                  _vm.hasTasks
                    ? _vm._l(_vm.previewTasks, function(task) {
                        return _c(
                          "div",
                          {
                            key: "dup-prev-task-" + task.id,
                            staticClass: "d-flex flex-row field-block"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "field-control-wrapper field-control-wrapper__title no-radius"
                              },
                              [
                                _c("div", { staticClass: "task-title" }, [
                                  _c("div", { staticClass: "field-wrap" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "field-value text-hover-bg"
                                      },
                                      [_vm._v(_vm._s(task.title))]
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__user"
                              },
                              [
                                _c("div", { staticClass: "custom-title" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-wrap field-wrap-users no-icon"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          task.user_name
                                            ? _c(
                                                "span",
                                                { staticClass: "info-bubbles" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "initials badge badge-primary",
                                                      attrs: {
                                                        title: task.user_name
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          task.user_initials ||
                                                            _vm.initialsFromName(
                                                              task.user_name
                                                            )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("Unassigned")]
                                              )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            false
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__due_date"
                                  },
                                  [_vm._m(10, true)]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status"
                              },
                              [
                                _c("div", { staticClass: "custom-title" }, [
                                  _c(
                                    "div",
                                    { staticClass: "field-wrap no-icon" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "field-value status-field-value",
                                          style: {
                                            backgroundColor:
                                              task.status_color || "#778899"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              task.status_name || "Not Started"
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status_note"
                              },
                              [
                                _c("div", { staticClass: "custom-title" }, [
                                  _c("div", { staticClass: "field-wrap" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "field-value text-hover-bg pt-20"
                                      },
                                      [_vm._v(_vm._s(task.notes || "—"))]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      })
                    : _c("div", { staticClass: "p-3 text-muted" }, [
                        _vm._v("No tasks")
                      ])
                ],
                2
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-header" }, [
      _c("div", { staticClass: "field-label" }, [
        _vm._v("Deliverable Description")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-6", staticStyle: { "padding-right": "10px" } },
      [
        _c("div", { staticClass: "field-box" }, [
          _c("div", { staticClass: "field-container--start_date" }, [
            _c("div", { staticClass: "field-header" }, [
              _c("div", { staticClass: "field-label" }, [_vm._v("Start Date")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field-wrap" }, [
              _c(
                "span",
                {
                  staticClass: "exclude-outside-click field-value text-hover-bg"
                },
                [_c("span", { staticClass: "text-muted" }, [_vm._v("No Date")])]
              )
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-6", staticStyle: { "padding-left": "10px" } },
      [
        _c("div", { staticClass: "field-box" }, [
          _c("div", { staticClass: "field-container--end_date" }, [
            _c("div", { staticClass: "field-header" }, [
              _c("div", { staticClass: "field-label" }, [_vm._v("End Date")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field-wrap" }, [
              _c(
                "span",
                {
                  staticClass: "exclude-outside-click field-value text-hover-bg"
                },
                [_c("span", { staticClass: "text-muted" }, [_vm._v("No Date")])]
              )
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-header" }, [
      _c("div", { staticClass: "field-label" }, [_vm._v("Coordinator")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-box__header" }, [
      _c("div", { staticClass: "add-contact-wrapper" }, [
        _c(
          "button",
          {
            staticClass:
              "add-contact-button exclude-outside-click d-inline-block",
            attrs: { disabled: "" }
          },
          [_vm._v("Who")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-box__header" }, [
      _c("div", { staticClass: "dropdown" }, [
        _c(
          "button",
          {
            staticClass:
              "add-resource-button exclude-outside-click d-inline-block",
            attrs: { disabled: "" }
          },
          [_vm._v("Resources")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__user"
      },
      [
        _c("div", { staticClass: "task-table-header" }, [
          _c("div", { staticClass: "field-label" }, [
            _c("span", [_vm._v("Assigned to")])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "task-table-header" }, [
      _c("div", { staticClass: "field-label" }, [
        _c("span", [_vm._v("Due Date")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status"
      },
      [
        _c("div", { staticClass: "task-table-header" }, [
          _c("div", { staticClass: "field-label" }, [
            _c("span", [_vm._v("Status")])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status_note"
      },
      [
        _c("div", { staticClass: "task-table-header" }, [
          _c("div", { staticClass: "field-label" }, [
            _c("span", [_vm._v("Notes")])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "custom-title" }, [
      _c("div", { staticClass: "field-wrap field-wrap-datepicker" }, [
        _c("span", { staticClass: "field-value text-hover-bg" }, [
          _vm._v("No Deadline")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }